import ApiService from "@/common/api/api.service";

let endpoint = "ProjetoGestao";

const CronogramaEtapa = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    buscarInvestimentos(idProjeto, rubrica, realizado) {
        return ApiService.get(`${endpoint}/investimento-${rubrica}-${realizado ? 'realizado': 'previsto'}?id=${idProjeto}`);
    },

    salvarInvestimento(form, rubrica,realizado){
        return ApiService.put(`${endpoint}/investimento-${rubrica}-${realizado ? 'realizado': 'previsto'}`, form);
    }
}

export default CronogramaEtapa;
